import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  RiMailLine,
  RiPhoneLine,
  RiLinkedinFill,
  RiTwitterFill,
  RiInstagramLine,
  RiFacebookFill,
  RiYoutubeFill,
  RiArrowRightUpLine,
  RiHeartFill,
  RiCopyrightLine,
  RiGlobalLine,
  RiUserLocationLine,
  RiUserLine,
} from "react-icons/ri";
import logo from "../assets/logo.png";

// ─── PAYMENT ICONS ───────────────────────────────────────────────

// Visa Icon
const VisaIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#1A1F71"/>
    <path d="M18.6 19.8L20.4 10.2H23.7L21.9 19.8H18.6ZM31.2 10.5C30.3 10.2 29.1 9.9 27.9 9.9C24.6 9.9 22.2 11.7 22.2 14.1C22.2 15.9 23.7 16.8 24.9 17.4C26.1 18 26.4 18.3 26.4 18.9C26.4 19.5 25.8 19.8 24.9 19.8C23.7 19.8 22.5 19.5 21.6 19.2L21.3 19.1L21 20.7C21.9 21 23.4 21.3 24.6 21.3C28.2 21.3 30.3 19.5 30.3 17.1C30.3 15.3 28.8 14.4 27.6 13.8C26.4 13.2 26.1 12.9 26.1 12.3C26.1 11.7 26.7 11.4 27.3 11.4C28.2 11.4 29.1 11.7 29.7 12L30 12.1L30.3 10.5L31.2 10.5ZM35.1 10.2C34.2 10.2 33.6 10.5 33.3 11.1L29.1 19.8H32.7L33.3 18.3H36.3L36.6 19.8H39.9L37.8 10.2H35.1ZM33.6 15.9L34.8 12.6L35.4 14.7L34.5 15.9H33.6ZM13.8 10.2L11.7 17.1L11.4 15.6L10.8 11.4C10.5 10.5 9.9 10.2 9 10.2H4.8L4.5 10.5L4.8 10.8C6.9 11.4 8.7 12.6 9.9 14.1L11.4 19.8H14.7L17.1 10.2H13.8Z" fill="white"/>
  </svg>
);

// Mastercard Icon
const MastercardIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#F79E1B"/>
    <circle cx="24" cy="15" r="10" fill="#EB001B" opacity="0.8"/>
    <circle cx="24" cy="15" r="10" fill="#F79E1B" opacity="0.6"/>
    <circle cx="19" cy="15" r="8" fill="#EB001B"/>
    <circle cx="29" cy="15" r="8" fill="#F79E1B"/>
    <path d="M24 8.5C22.5 10 21.5 12 21.5 15C21.5 18 22.5 20 24 21.5C25.5 20 26.5 18 26.5 15C26.5 12 25.5 10 24 8.5Z" fill="#FF5F00"/>
  </svg>
);

// PayPal Icon
const PayPalIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#003087"/>
    <path d="M11.5 8.5L9.5 20.5H13.5L14.5 14.5H16.5C19.5 14.5 21.5 13 22 10.5C22.3 9 22 8 21 7.5C20.5 7 19.5 6.5 18 6.5H11.5L11.5 8.5Z" fill="#009CDE"/>
    <path d="M16.5 14.5L15.5 20.5H18.5L19.5 14.5H16.5Z" fill="#009CDE"/>
    <path d="M13.5 14.5L12.5 20.5H15.5L16.5 14.5H13.5Z" fill="#009CDE"/>
    <path d="M18 12.5C18.8 12.5 19.5 12.8 20 13.2C20.3 13.5 20.5 13.8 20.5 14.2C20.5 14.8 20.2 15.3 19.7 15.7C19.2 16 18.6 16.2 18 16.2H16.8L17.2 13.5H18V12.5Z" fill="#003087"/>
    <path d="M13.5 10.5H12.5L11.5 16.5H13.5L13.5 10.5Z" fill="#003087"/>
  </svg>
);

// Stripe Icon
const StripeIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#6772E5"/>
    <path d="M24 8.5C20.5 8.5 18 10.5 18 13.5C18 16.5 20.5 18.5 24 18.5C26.5 18.5 28.5 17.5 29.5 16V13.5C28 15 25.5 15.5 23.5 14.5C22 14 21.5 13 22 12.5C22.5 12 23.5 12 24.5 12.5C25.5 13 26 14 26 15H28.5C28 13 26.5 11.5 24.5 11C23.5 10.5 22.5 10.5 21.5 11C20 11.5 19 13 19.5 14.5C20 16 21.5 17 23.5 17C26 17 28 15.5 29 13.5C29.5 12.5 30 11.5 30 10.5V8.5H27.5C26.5 8.5 25.5 8.5 24 8.5Z" fill="white"/>
    <path d="M24 8.5C27.5 8.5 30 10.5 30 13.5C30 16.5 27.5 18.5 24 18.5C20.5 18.5 18 16.5 18 13.5C18 10.5 20.5 8.5 24 8.5Z" fill="white" opacity="0.3"/>
  </svg>
);

// Amex Icon
const AmexIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#006FCF"/>
    <path d="M14.5 11.5L12.5 15.5L14.5 19.5H11.5L9.5 15.5L11.5 11.5H14.5Z" fill="white"/>
    <path d="M17.5 11.5L15.5 15.5L17.5 19.5H14.5L12.5 15.5L14.5 11.5H17.5Z" fill="white"/>
    <path d="M20.5 11.5L18.5 15.5L20.5 19.5H17.5L15.5 15.5L17.5 11.5H20.5Z" fill="white"/>
    <path d="M23.5 11.5L21.5 15.5L23.5 19.5H20.5L18.5 15.5L20.5 11.5H23.5Z" fill="white"/>
    <rect x="26" y="11" width="4" height="1" fill="white"/>
    <rect x="26" y="13" width="4" height="1" fill="white"/>
    <rect x="26" y="15" width="4" height="1" fill="white"/>
    <rect x="26" y="17" width="4" height="1" fill="white"/>
    <text x="36" y="18" fontSize="10" fill="white" fontFamily="Arial" fontWeight="bold">AMEX</text>
  </svg>
);

// Apple Pay Icon
const ApplePayIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#000000"/>
    <path d="M24 8.5C23.5 7 22 6 20.5 6C19 6 17.5 7 17 8.5C16.5 10 17 11.5 18.5 12.5C17.5 13.5 17 15 17.5 16.5C18 18 19.5 19 21 19C22.5 19 24 18 24.5 16.5C25 15 24.5 13.5 23 12.5C24 11.5 24.5 10 24 8.5Z" fill="white"/>
    <path d="M27.5 11C25.5 11 24 12.5 24 14.5C24 16.5 25.5 18 27.5 18C29.5 18 31 16.5 31 14.5C31 12.5 29.5 11 27.5 11Z" fill="white"/>
    <text x="33" y="18" fontSize="9" fill="white" fontFamily="Arial" fontWeight="bold">Pay</text>
  </svg>
);

// Google Pay Icon
const GooglePayIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#FFFFFF" stroke="#E5E5E5" strokeWidth="1"/>
    <circle cx="16" cy="15" r="8" fill="#4285F4"/>
    <circle cx="24" cy="15" r="8" fill="#EA4335"/>
    <circle cx="20" cy="15" r="8" fill="#FBBC04"/>
    <text x="33" y="18" fontSize="8" fill="#3C4043" fontFamily="Arial" fontWeight="bold">Google Pay</text>
  </svg>
);

// Alipay Icon
const AlipayIcon = () => (
  <svg viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ height: '20px', width: 'auto' }}>
    <rect width="48" height="30" rx="4" fill="#1677FF"/>
    <text x="12" y="19" fontSize="12" fill="white" fontFamily="Arial" fontWeight="bold">支付宝</text>
    <text x="34" y="19" fontSize="8" fill="white" fontFamily="Arial" fontWeight="bold">Alipay</text>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // ✅ Static dummy contact data
  const contactInfo = {
    phone: "+91 (9848) 14 1833",
    email: "contact@meetings21.com",
    name: "Meetings21 Support",
  };

  const footerLinks = {
    quickLinks: [
      { name: "Home", path: "/" },
      { name: "About Us", path: "/about" },
      { name: "Speakers", path: "/speakers" },
      { name: "Summits", path: "/agenda" },
      { name: "Register", path: "/register" },
      { name: "Contact", path: "/contact" },
    ],
    legal: [
      { name: "Privacy Policy", path: "/privacy-policy" },
      { name: "Cookie Policy", path: "/cookies" },
      { name: "Code of Conduct", path: "/code-of-conduct" },
    ],
  };

  const socialLinks = [
    { icon: RiLinkedinFill, url: "#", label: "LinkedIn", color: "hover:text-[#0077B5]" },
    { icon: RiTwitterFill, url: "#", label: "Twitter", color: "hover:text-[#1DA1F2]" },
    { icon: RiInstagramLine, url: "#", label: "Instagram", color: "hover:text-[#E4405F]" },
    { icon: RiFacebookFill, url: "#", label: "Facebook", color: "hover:text-[#1877F2]" },
    { icon: RiYoutubeFill, url: "#", label: "YouTube", color: "hover:text-[#FF0000]" },
  ];

  const paymentMethods = [
    { name: "Visa", icon: VisaIcon },
    { name: "Mastercard", icon: MastercardIcon },
    { name: "Apple Pay", icon: ApplePayIcon },
    { name: "Google Pay", icon: GooglePayIcon },
    { name: "Alipay", icon: AlipayIcon },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <footer className="relative bg-white">
      {/* Top Gradient Line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-600 to-transparent opacity-50"></div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-6 pt-20 pb-10">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:grid-cols-[200px_1fr_1fr_1fr]"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Company Info - Logo */}
          <motion.div variants={itemVariants} className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 mt-8">
              <div className="relative" style={{ width: '160px', height: 'auto' }}>
                <img
                  src={logo}
                  alt="Meeting21 Logo"
                  style={{ width: '100%', height: 'auto', maxHeight: '120px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </Link>

            {/* Social Links */}
            <div className="flex space-x-2 mt-6">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -3, scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 hover:bg-gray-100 ${social.color}`}
                  style={{ backgroundColor: "#F3F4F6", color: "#6B7280" }}
                  title={social.label}
                >
                  <social.icon className="text-lg" />
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Navigation Links */}
          <motion.div variants={itemVariants} className="lg:col-span-1">
            <h3 className="text-lg font-semibold mb-6 relative inline-block text-gray-900">
              Navigation
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-blue-600"></span>
            </h3>
            <ul className="space-y-3">
              {footerLinks.quickLinks.map((link, index) => (
                <motion.li
                  key={index}
                  whileHover={{ x: 5 }}
                  transition={{ type: "spring", stiffness: 400 }}
                >
                  <Link
                    to={link.path}
                    className="transition-colors flex items-center space-x-2 group hover:text-blue-600 text-gray-600"
                  >
                    <RiArrowRightUpLine className="text-sm opacity-0 group-hover:opacity-100 transition-all transform group-hover:translate-x-1 text-blue-600" />
                    <span>{link.name}</span>
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Legal */}
          <motion.div variants={itemVariants} className="lg:col-span-1">
            <h3 className="text-lg font-semibold mb-6 relative inline-block text-gray-900">
              Legal
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-blue-600"></span>
            </h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <motion.li
                  key={index}
                  whileHover={{ x: 5 }}
                  transition={{ type: "spring", stiffness: 400 }}
                >
                  <Link
                    to={link.path}
                    className="transition-colors flex items-center space-x-2 group hover:text-blue-600 text-gray-600"
                  >
                    <RiArrowRightUpLine className="text-sm opacity-0 group-hover:opacity-100 transition-all transform group-hover:translate-x-1 text-blue-600" />
                    <span>{link.name}</span>
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Us Section */}
          <motion.div variants={itemVariants} className="lg:col-span-1">
            <h3 className="text-lg font-semibold mb-6 relative inline-block text-gray-900">
              Contact Us
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-blue-600"></span>
            </h3>

            <div className="space-y-5">
              {/* Contact Person */}
              <div className="group cursor-pointer">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group-hover:bg-blue-50 bg-gray-100">
                    <RiUserLine className="text-sm text-blue-600" />
                  </div>
                  <span className="text-sm font-medium transition-colors group-hover:text-blue-600 text-gray-900">
                    Contact Person
                  </span>
                </div>
                <span className="text-sm text-gray-600 font-semibold">
                  {contactInfo.name}
                </span>
              </div>

              {/* Phone */}
              <div className="group cursor-pointer">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group-hover:bg-blue-50 bg-gray-100">
                    <RiPhoneLine className="text-sm text-blue-600" />
                  </div>
                  <span className="text-sm font-medium transition-colors group-hover:text-blue-600 text-gray-900">
                    Phone
                  </span>
                </div>
                <a
                  href={`tel:${contactInfo.phone.replace(/[^0-9+]/g, '')}`}
                  className="text-sm transition-colors hover:text-blue-600 text-gray-600 font-semibold"
                >
                  {contactInfo.phone}
                </a>
              </div>

              {/* Email */}
              <div className="group cursor-pointer">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group-hover:bg-blue-50 bg-gray-100">
                    <RiMailLine className="text-sm text-blue-600" />
                  </div>
                  <span className="text-sm font-medium transition-colors group-hover:text-blue-600 text-gray-900">
                    Email
                  </span>
                </div>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-sm transition-colors hover:text-blue-600 text-gray-600 font-semibold break-all"
                >
                  {contactInfo.email}
                </a>
              </div>

              {/* Live Support */}
              <div className="group">
                <div className="flex items-center space-x-3 mb-2">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group-hover:bg-blue-50 bg-gray-100">
                    <RiUserLocationLine className="text-sm text-blue-600" />
                  </div>
                  <span className="text-sm font-medium transition-colors group-hover:text-blue-600 text-gray-900">
                    Live Support
                  </span>
                </div>
                <span className="text-sm text-gray-600">
                  Mon-Fri, 9 AM - 6 PM IST
                </span>
              </div>

              {/* Office Location Link */}
              <div className="pt-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-300 hover:scale-105 group bg-blue-600 text-white hover:bg-blue-700"
                >
                  <RiGlobalLine className="text-sm" />
                  <span className="text-sm font-medium">Visit Our Office</span>
                  <RiArrowRightUpLine className="text-sm opacity-0 group-hover:opacity-100 transition-all" />
                </Link>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Bottom Bar */}
        <motion.div
          className="mt-16 pt-8 border-t border-gray-200"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <RiCopyrightLine />
              <span>{currentYear} Meetings21. All rights reserved.</span>
            </div>

            {/* Made with love */}
            <div className="flex items-center space-x-1 text-sm text-gray-500">
              <span>Made with</span>
              <RiHeartFill className="text-red-500 animate-pulse" />
              <span>by Meetings21 Team</span>
            </div>

            {/* Payment Methods */}
            <div className="flex items-center space-x-3">
              <div className="text-xs text-gray-500 font-medium">Secured Payments:</div>
              <div className="flex space-x-2">
                {paymentMethods.map((method, index) => (
                  <div
                    key={index}
                    className="w-20 h-12 rounded-lg flex items-center justify-center bg-gray-100 border border-gray-200 transition-all hover:scale-105 hover:shadow-md"
                    title={method.name}
                  >
                    <method.icon />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Legal Disclaimer */}
          <div className="mt-4 text-center text-xs max-w-3xl mx-auto text-gray-400">
            <p>
              Meetings21 is a registered trademark. All product names, logos, and
              brands are property of their respective owners. All company,
              product and service names used in this website are for
              identification purposes only.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-50 to-transparent pointer-events-none"></div>
    </footer>
  );
};

export default Footer;